module.exports = __webpack_public_path__ + "static/media/st.3589e34b.svg";